import { appConfig } from '../../../config/config.app';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export interface MarriottTokenRequest {
  code: string;
  grant_type: string;
  redirect_uri: string;
  state?: string;
  scope: string;
}
export interface AuthToken {
  access_token: string;
  expires_in: number;
  id_token: string;
  scope: string;
  refresh_token: string;
  token_type: string;
}

export const marriottTokenRequest = async (requestBody: MarriottTokenRequest) => {
  try {
    /**
     * MARRIOTT TOKEN ENDPOINT
    const result = await post(
      'https://gatewaydsapuat3.marriott.com/v3/ent-auth/sso/token',
      {
        body: JSON.stringify(requestBody),
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept-Language': 'en-US',
          Authorization: 'Basic bWdtcmVzX2F1dGg6c1VOem1zZ2VURkNBUnhaYSF2M3lDQCY2aGRJa1RX',
        }),
      },
      '',
      false,
      true,
      true,
    );
    */

    let formData = '';
    for (const key in requestBody) {
      formData += formData ? '&' : '';
      formData += `${key}=${requestBody[key as keyof MarriottTokenRequest]}`;
    }

    const result = await post(
      '/marriott/token',
      {
        body: formData,
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      },
      appConfig.authorizationApiUrl,
    );

    evaluateResponseErrorCode(result.response);
    if (result?.response?.error) throw result.response.error;

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
